import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { JobService } from '../services/job.service';
import { ConfirmationService } from '../services/confirmation.service';
import { ConversationService } from '../services/conversation.service';
import { Globals } from '../objects/Globals';
import { Job } from '../objects/JobCommand';
import { Router } from '@angular/router';
import { SwiperConfigInterface } from 'node_modules/ngx-swiper-wrapper';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-joblist',
  templateUrl: './joblist.component.html',
  styleUrls: ['./joblist.component.css']
})
export class JoblistComponent implements OnInit {

  jobList:Job[];
  isBusy:boolean = true;
  private componentId:string;
  private currentPage: number;
  private availablePageSize: number;
  private loaderConfig : any;
  private availableImages = ['VIEWPR','CREATEPR', 'VIEWPO', 'CREATEPO', 'VIEWRFQ', 'CREATERFQ', 'VIEWSN', 'CREATESN', 'VIEWIV', 'CREATEIV', 'VIEWEBID', 'CREATEEBID', 'VIEWSUPPLIER', 'MANAGESUPPLIER', 'Template'];
  

  @Input() jobListType:string;

  constructor(private jobService:JobService,private confirmationService: ConfirmationService,private conversationService : ConversationService, 
    private globals:Globals,private router:Router, private themeSettingService:ThemeSettingService, private workspaceService: WorkspaceService) { }

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 5,
    keyboard: true,
    navigation: true,
    pagination: false,
    breakpoints: {
      // when window width is <= 480px
      380: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      // when window width is <= 480px
      992: {
        slidesPerView: 3
      },
      1366: {
        slidesPerView: 4
      },
      // when window width is <= 640px
      1600: {
        slidesPerView: 5
      }
    }
  };

  refreshJobListCard(){
    this.isBusy = true;
    if(this.componentId){
      this.jobService.getJobList(this.componentId).subscribe(result=>{
        var jobResult = JSON.parse(result);
        this.jobList = jobResult.sort(this.sortJobList);
        this.availablePageSize = this.jobList.length;
        this.currentPage = 1;
        this.isBusy = false;
      }, error => {
        this.isBusy = false;
      });
    }
  }

  sortJobList(a: Job,b: Job) {
    if (a.JobOrder < b.JobOrder)
      return -1;
    if (a.JobOrder > b.JobOrder)
      return 1;
    return 0;
  }

  triggerJob(jobId:string){
    if(jobId){
      this.isBusy = true;
      this.jobService.triggerJob(this.componentId, jobId).subscribe(result=> {
        var resultObject = JSON.parse(result);
        if(resultObject.ReturnType == "0"){
          if(resultObject.Arguments){
            var path = [];
            resultObject.Arguments.forEach(element => {
              path.push(element);
            });;
            this.router.navigate(path);
          }
        }
        this.isBusy = false;
      }, error => {
        this.isBusy = false;
      });
    }
  }

  prevPage(){

  }

  nextPage(){
    
  }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    if(this.globals.Session){
      this.jobService.createJobList(this.jobListType).subscribe(result=>{
        this.componentId = result;
        this.refreshJobListCard();
      });
    }
  }

  pullPopup($event, job: Job) {    
    this.confirmationService.confirm(
      "Add Quick Phrase for " + job.JobName,
      "",
      ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
      .subscribe((respond) => {
        if (respond.answer == "OK"){
          //this.isBusy = true;
          this.conversationService.saveUtteranceForJob(respond.inputText, job.JobId).subscribe(result => {
            console.log(result);
          })
          
        }
      });

    $event.stopPropagation();
  }
}
